import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate, useParams } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import type { Playlist } from 'types/playlist'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import PlaylistShareDialog from 'components/modals/playlist/share'
type Props = {
  location: Location
}

const SharePlaylist = (props: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { playlistId } = useParams<{ playlistId: string }>()
  const playlist: Playlist | null | undefined = useSelector(state =>
    getPlaylist(state, {
      id: playlistId ? parseInt(playlistId, 10) : undefined,
    }),
  )
  const closeModal = useCallback(() => navigate('/'), [navigate])
  const onShare = useCallback(
    (shareId: number) => {
      if (playlist) {
        const { playlist_id } = playlist
        const path = `/explorer/playlists/${playlist_id}/shared/${shareId}`
        navigate(path)
      }
    },
    [playlist, navigate],
  )
  return (
    <PlaylistShareDialog
      playlist={playlist}
      onShare={onShare}
      onClose={closeModal}
    />
  )
}

export default SharePlaylist
